<template>
  <div>
    <b-modal
      v-model="openModal"
      centered
      :size="modalSize"
      hide-header
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      static
      class="loading-modal"
    >
      <div>
        <b-row align-v="center" :class="modalWrapperClass">
          <b-col
            v-if="background_img != ''"
            md="12"
            style="
              width: 100%;
              min-height: 15rem;
              margin-top: 0;
              text-align: center;
            "
            class="text-center"
          >
            <img :src="background_img" style="width: 12rem" />
          </b-col>
          <b-col cols="12" style="margin: 0rem 0">
            <b-progress
              show-value
              show-progress
              :max="100"
              :style="progressBarStyle"
            >
              <b-progress-bar
                :value="value"
                :variant="variant || 'success'"
                :animated="animated"
              >
                <span
                  style="color: black; text-align: center"
                  v-if="background_img == ''"
                >
                  {{ label }}
                </span>
              </b-progress-bar>
            </b-progress>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  component: 'ModalLoading',

  props: {
    label: {
      type: String,
      default: 'Gerando Relatório... ',
    },
    background_img: {
      type: String,
      default: '',
    },
    value: {
      type: Number | String,
      default: 0.0,
    },

    openModal: {
      type: Boolean,
      default: false,
    },

    variant: {
      type: String,
      default: 'success',
    },

    animated: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    modalSize() {
      if (this.background_img != '') {
        return 'xl'
      } else {
        return 'sm'
      }
    },
    modalWrapperClass() {
      if (this.background_img != '') {
        return 'my-8'
      } else {
        return ''
      }
    },
    progressBarStyle() {
      if (this.background_img != '') {
        return 'height:.4rem; color: red; width:30rem; margin: 0 auto;  max-width: 100%;'
      } else {
        return 'height:1.6rem; width: 100%;  max-width: 100%;'
      }
    },
  },
}
</script>

<style>
.progress {
  background-color: lightgray;
  margin-bottom: 0;
}
</style>
